import { createFileRoute } from '@tanstack/react-router';
import RequestedDetailsPage from '@/features/onboarding/RequestedDetailsPage';

export const Route = createFileRoute('/requested-details')({
  staticData: { hideShell: true, breadcrumb: 'Required Details', breadcrumbKey: 'K_BREADCRUMB_REQUIRED_DETAILS' },
  component: RequestedDetailsPage,
});
